import { AppUserService } from '@ceres/shared/services';
import { Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { rolePermissions } from '@ceres/domain';
import { FeatureOf, FEATURES } from '@ceres/feature-toggles';
import { CeresFeaturesConfig } from '@ceres/shared/features';
import { environment } from '../../../environments/environment';
import { nestedNavigationMenus } from './nestedNavigationMenus';

@Component({
    selector: 'ceres-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavbarComponent implements OnInit {
    readonly features = inject<FeatureOf<CeresFeaturesConfig>>(FEATURES);
    translateService = inject(TranslateService);
    appUserService = inject(AppUserService);
    router = inject(Router);

    @Input() isPartlyOpen: boolean;
    @Input() isMenuOpen: boolean;
    @Output() partlyOpen = new EventEmitter<boolean>();
    @Output() menuOpen = new EventEmitter<boolean>();
    protected nestedNavigationMenus = nestedNavigationMenus;
    protected permission = rolePermissions;
    public currentUser;
    protected documentsLink = environment.servicesDocumentationLink;

    ngOnInit(): void {
        this.appUserService.loggedInUser$.asObservable().subscribe((user) => {
            this.currentUser = user;
        });
    }

    closeMenu() {
        if (!this.isMenuOpen) {
            return;
        }
        this.isMenuOpen = false;
        this.menuOpen.emit(false);
        this.partlyOpen.emit(false);
    }

    openSubMenu(elem, item: number) {
        this.isMenuOpen = true;
        this.menuOpen.emit(true);
        for (let i = 0; i < nestedNavigationMenus.length; i++) {
            if (i === item) {
                nestedNavigationMenus[item].open = !nestedNavigationMenus[item].open;
            } else {
                nestedNavigationMenus[i].open = false;
            }
        }
    }
}
